import {
  DropdownOption,
  EmployeeProductionDialog,
  EmployeeProductionState,
  ProductionRecipeItem,
} from "./employeeProductionTypes";

export type EmployeeProductionAction =
  | { type: "lots-loaded"; lots: DropdownOption[] }
  | { type: "production-loading"; lot: DropdownOption }
  | { type: "recipe-loaded"; items: ProductionRecipeItem[] }
  | { type: "barcode-changed"; barcode: string }
  | { type: "barcode-loading" }
  | { type: "dialog-opened"; dialog: EmployeeProductionDialog }
  | { type: "dialog-closed" }
  | { type: "mutation-started"; status: "saving" | "updating" | "deleting" }
  | { type: "mutation-complete"; items: ProductionRecipeItem[] }
  | {
      type: "expanded-rows-changed";
      rows: Record<string, boolean> | ProductionRecipeItem[] | null;
    }
  | { type: "idle" };

export const employeeProductionInitialState: EmployeeProductionState = {
  lots: [],
  selectedLot: null,
  barcode: "",
  recipeItems: [],
  expandedRows: null,
  status: "initializing",
  dialog: { type: "none" },
};

export function employeeProductionReducer(
  state: EmployeeProductionState,
  action: EmployeeProductionAction,
): EmployeeProductionState {
  switch (action.type) {
    case "lots-loaded":
      return { ...state, lots: action.lots, status: "idle" };
    case "production-loading":
      return {
        ...state,
        selectedLot: action.lot,
        recipeItems: [],
        expandedRows: null,
        status: "loading-production",
      };
    case "recipe-loaded":
      return { ...state, recipeItems: action.items, status: "idle" };
    case "barcode-changed":
      return { ...state, barcode: action.barcode };
    case "barcode-loading":
      return { ...state, status: "looking-up-barcode" };
    case "dialog-opened":
      return { ...state, dialog: action.dialog, status: "idle" };
    case "dialog-closed":
      return { ...state, dialog: { type: "none" } };
    case "mutation-started":
      return { ...state, status: action.status };
    case "mutation-complete":
      return {
        ...state,
        recipeItems: action.items,
        barcode: "",
        status: "idle",
        dialog: { type: "none" },
      };
    case "expanded-rows-changed":
      return { ...state, expandedRows: action.rows };
    case "idle":
      return { ...state, status: "idle" };
  }
}
